(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();

      this.setHeaderHeight =
        this.setHeaderHeight.bind(this);
    }


    connectedCallback() {

      this.header =
        document.querySelector(
          '.section-header'
        );


      this.mobileMediaQuery =
        window.matchMedia(
          '(max-width: 990px)'
        );


      this.headerIsAlwaysSticky =
        this.getAttribute(
          'data-sticky-type'
        ) === 'always'
        ||
        this.getAttribute(
          'data-sticky-type'
        ) === 'reduce-logo-size';


      this.headerBounds =
        {};


      this.setHeaderHeight();


      this.mobileMediaQuery.addEventListener(
        'change',
        this.setHeaderHeight
      );


      if (
        this.headerIsAlwaysSticky
      ) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }


      this.currentScrollTop =
        0;


      this.preventReveal =
        false;


      this.predictiveSearches =
        this.querySelectorAll(
          'predictive-search'
        );


      this.onScrollHandler =
        this.onScroll.bind(this);


      this.hideHeaderOnScrollUp =
        () => {
          this.preventReveal = true;
        };


      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );


      this.createObserver();
    }


    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }


    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener(
        'change',
        this.setHeaderHeight
      );


      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }


    createObserver() {

      let observer =
        new IntersectionObserver(
          (entries) => {

            this.headerBounds =
              entries[0].intersectionRect;


            observer.disconnect();

          }
        );


      observer.observe(
        this.header
      );

    }


    onScroll() {

      const scrollTop =
        window.pageYOffset
        ||
        document.documentElement.scrollTop;


      if (
        [...this.predictiveSearches]
          .some(
            (predictiveSearch) =>
              predictiveSearch.isOpen
          )
      ) {
        return;
      }


      if (
        scrollTop > this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );


        if (
          this.preventHide
        ) {
          return;
        }


        requestAnimationFrame(
          this.hide.bind(this)
        );

      }

      else if (
        scrollTop < this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );


        if (
          !this.preventReveal
        ) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        } else {

          window.clearTimeout(
            this.isScrolling
          );


          this.isScrolling =
            setTimeout(
              () => {

                this.preventReveal =
                  false;

              },
              66
            );


          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      }

      else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );


        requestAnimationFrame(
          this.reset.bind(this)
        );

      }


      this.currentScrollTop =
        scrollTop;

    }


    hide() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );


      this.closeMenuDisclosure();
      this.closeSearchModal();

    }


    reveal() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }


    reset() {

      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }


      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }


    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures
        ||
        this.header.querySelectorAll(
          'header-menu'
        );


      this.disclosures.forEach(
        (disclosure) =>
          disclosure.close()
      );

    }


    closeSearchModal() {

      this.searchModals =
        this.searchModals
        ||
        this.header.querySelectorAll(
          'details-modal'
        );


      this.searchModals.forEach(
        (searchModal) =>
          searchModal.close(false)
      );

    }

  }


  document.addEventListener(

    'open',

    (event) => {

      if (
        !(event.target instanceof HTMLElement)
        ||
        !event.target.matches(
          'shopify-account'
        )
      ) {
        return;
      }


      const bottom =
        Math.max(
          0,
          Math.round(
            event.target
              .getBoundingClientRect()
              .bottom
          )
        );


      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );

    },

    true

  );


  if (
    !customElements.get(
      'sticky-header'
    )
  ) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vj-barra-anuncios"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vj-announcement-slider')) return;

    class VJAnnouncementSlider extends HTMLElement {
      connectedCallback() {
        this.init();
        if (!this.controller) this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-vj-slide]'));
        if (!this.slides.length) return;

        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.interval = Math.max(1000, Number(this.dataset.interval) || 4000);
        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.hovered = this.matches(':hover');
        this.editorPaused = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => this.schedule();
        this.motion.addEventListener('change', this.onMotionChange);

        const previous = this.querySelector('[data-vj-previous]');
        const next = this.querySelector('[data-vj-next]');
        const multiple = this.slides.length > 1;
        previous.hidden = !multiple;
        next.hidden = !multiple;
        previous.addEventListener('click', () => this.show(this.index - 1, true), options);
        next.addEventListener('click', () => this.show(this.index + 1, true), options);

        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (this.isConnected && this.controller) this.schedule();
          });
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide =>
            slide.dataset.blockId === String(event.detail?.blockId) || slide.contains(event.target)
          );
          if (index < 0) return;
          this.editorPaused = true;
          this.show(index);
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.schedule();
        }, options);

        this.show(this.index);
      }

      show(index, announce = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          slide.hidden = position !== this.index;
        });
        const status = this.querySelector('[data-vj-status]');
        if (status) {
          status.textContent = announce
            ? this.slides[this.index].querySelector('.vj-announcement__text').textContent.trim()
            : '';
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.isConnected || !this.autoplay || this.slides.length < 2 ||
            this.motion.matches || document.hidden || this.editorPaused ||
            this.contains(document.activeElement) || (this.pauseOnHover && this.hovered)) return;
        this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        if (this.motion && this.onMotionChange) {
          this.motion.removeEventListener('change', this.onMotionChange);
        }
      }
    }

    customElements.define('vj-announcement-slider', VJAnnouncementSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
